import type { StorefrontPageProps } from '@kitup/brand';
import type { JSX } from 'react';
import { Link } from 'react-router';
import { useAuth } from '../auth/context.js';
import { useLegal } from '../brand/legal-context.js';
import { useStorefront } from '../brand/storefront-context.js';
import { LegalLinks } from '../components/LegalLinks.js';
import { ContactLinks } from '../components/ContactLinks.js';
import { useI18n } from '../i18n/context.js';

/**
 * `/` and `/pricing`: the brand's own pages, given what only the app knows.
 *
 * The pages come from the brand (`Storefront`); this is the one place that
 * hands them the session, the router's link and the shared footer.
 */
export function StorefrontPage({ page }: { readonly page: 'landing' | 'pricing' }): JSX.Element {
  const storefront = useStorefront();
  const legal = useLegal();
  const { locale } = useI18n();
  const { user, isBootstrapping, logout } = useAuth();

  const props: StorefrontPageProps = {
    locale,
    user: user ? { name: user.name } : null,
    authPending: isBootstrapping,
    onSignOut: () => void logout(),
    Link,
    footer: (
      <>
        <LegalLinks />
        {legal.footerContacts ? <ContactLinks contacts={legal.footerContacts} /> : null}
        {legal.footerLine ? <p>{legal.footerLine}</p> : null}
      </>
    ),
  };

  return <>{storefront[page](props)}</>;
}
